<template>
  <div class="flex px-2 bg-theme-font text-white py-2 my-3">
    <div class="flex flex-col items-center gap-2 max-w-2xl mx-auto">
      <h3 class="text-white">{{ $t('spotdetail.spot_fixed_title') }}</h3>
      <ButtonSubmit
        v-if="!spot.userData?.spotAuthor"
        :disable-submit="spot.userData?.proposedFix"
        :color="'white'"
        @click="proposeFix()"
        :loading="proposeFixLoading"
        :error="proposeFixError"
        :title="
          spot.userData?.proposedFix
            ? $t('spotdetail.spot_fixed_already_voted')
            : $t('spotdetail.spot_fixed_vote_button_title')
        "
      />
      <SpotDetailsFixProposalProgressBar :numberOfVotes="numberOfFixedProposals" />
      <i18n-t
        v-if="!spot.userData?.spotAuthor"
        keypath="spotdetail.spot_fixed_text"
        scope="global"
        tag="p"
        class="text-center text-white"
      >
        <template v-slot:people>{{
            3 - numberOfFixedProposals
          }}
        </template>
      </i18n-t
      >
      <i18n-t
        v-else
        keypath="spotdetail.spot_fixed_owner_text"
        scope="global"
        tag="p"
        class="text-center text-white"
      >
        <template v-slot:people>{{ numberOfFixedProposals }}</template>
      </i18n-t>
      <div v-if="!spot.userData?.spotAuthor"
           class="flex flex-col gap-2 justify-center">
        <div class="flex justify-center">
          <ButtonSubmit
            :title="t('spotdetail.spot_got_fixed_missing_image_button_title')"
            color="white"
            class="flex-grow-0"
            onclick="add_fix_image_modal.showModal()" />
          <Modal id="add_fix_image_modal">
            <div class="flex flex-col gap-2">
              <h2>{{ $t('spotdetail.add_image_title') }}</h2>
              <SpotDetailsAddImage :spot="spot"
                                   name="add-fix-image"
                                   @success="closeAddImageModal()" />
            </div>
          </Modal>
        </div>
      </div>
      <Modal id="set_fixed_modal" ref="setFixedModal">
        <div class="flex flex-col gap-2">
          <h2 class="text-black mr-2 mb-3">
            {{ $t('spotdetail.spot_fixed_title') }}
          </h2>
          <ButtonSubmit
            :title="$t('spotdetail.spot_fixed_button_title')"
            :loading="setFixedLoading"
            :error="setFixedError"
            @click="setFixed()"
          />
        </div>
      </Modal>
    </div>
  </div>
</template>
<script setup lang="ts">

const { authenticated, user } = useAuth();
const { t } = useI18n();

const props = defineProps<{ spot: SpotDetail }>();

const numberOfFixedProposals = ref(props.spot.numberOfFixedProposals);
const proposeFixLoading = ref(false);
const proposeFixError = ref(false);

const setFixedModal = ref();
const setFixedLoading = ref(false);
const setFixedError = ref(false);


function closeAddImageModal() {
  (document.getElementById('add_fix_image_modal') as HTMLFormElement).close();
}


function setFixed() {
  setFixedLoading.value = true;
  setFixedError.value = false;

  useApiAuth()
    .post<boolean>('spots/' + props.spot.id + '/setFixed')
    .then((result) => {
      props.spot.gotFixed = result;
      setFixedModal.value.close();
    })
    .catch((theError) => {
      setFixedError.value = true;
      console.log(theError);
    })
    .finally(() => {
      setFixedLoading.value = false;
    });
}

function proposeFix() {
  proposeFixLoading.value = true;
  proposeFixError.value = false;

  useApiAuth()
    .post<ProposeFixResponse>('spots/' + props.spot.id + '/proposeFix')
    .then((result) => {
      props.spot.gotFixed = result.gotFixed;
      numberOfFixedProposals.value = result.numberOfVotes;
      if (props.spot.userData) {
        props.spot.userData.proposedFix = true;
      }
      proposeFixLoading.value = false;
    })
    .catch((theError) => {
      proposeFixLoading.value = false;
      proposeFixError.value = true;
      console.log(theError);
    });
}
</script>
